import { render, staticRenderFns } from "./OverviewLpg.vue?vue&type=template&id=0a657c1e"
import script from "./OverviewLpg.vue?vue&type=script&lang=js"
export * from "./OverviewLpg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports